/**
 * Created by JackCui on 2021/12/1
 */

import * as FeComsShare from 'fe-coms-share/paas'
import {props, schemaHandle} from './components/schema-config'

// 全局组件
import Components from './components'
// 全局render组件
import Renders from './renders'
// 功能函数
import CatchStore from './utils/catch-state'
import StoreModules from './store/catch-store-modules'
import {routerPush} from '../../basis/fe-link'

// 导出注册全局
export default {
  install: function (Vue) {
    // 注册全局组件
    for (let k in Object.assign(Components, Renders)) {
      if (!Components.hasOwnProperty(k)) {
        continue
      }

      Vue.component(k, Components[k])
    }

    // 注册全局缓存
    for (let v in StoreModules) {
      CatchStore.install(StoreModules[v])
    }

    // todo 函数=>对象先用系统默认  注册全局com-share
    FeComsShare.install({
      customHandle: schemaHandle,
      componentsProps: props
    })

    // 自定义全局方法
    Vue.prototype.$CatchStore = CatchStore
    Vue.prototype.$routerPush = routerPush
  }
}
